import { getToken } from "./authHeaderService";
import { apiInstance } from "./axiosService";
import { convertObjToQueryParams } from "./commonHelper";

export const getSkill = (payload) => {
    return apiInstance.get("skill/getSkill" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addSkill = (payload) => {
    return apiInstance.post("skill/addSkill", payload, { headers: getToken() });
};

export const deleteSkillById = (payload) => {
    return apiInstance.post("skill/deleteSkillById", payload, { headers: getToken() });
};

export const getSkillBenefitsById = async (payload) => {
    const res = await apiInstance.get(`skill/${payload}`);
    let data = { data: { records: res?.data?.benefits, totalRecords: res?.data?.benefits?.length }, ok: res?.ok }
    return data;
};

export const addSkillBenefit = (payload) => {
    return apiInstance.post("skill/addSkillBenefit", payload, { headers: getToken() });
};

export const deleteSkillBenefitById = async (payload) => {
    const res = await apiInstance.delete(`skill/deleteSkillBenefitById/${payload?.id}`, { headers: getToken() });
    return res;
};

export const getSkillMediaById = async (payload) => {
    const res = await apiInstance.get(`skill/${payload}`, { headers: getToken() });
    let data = { data: { records: res?.data?.media, totalRecords: res?.data?.media?.length }, ok: res?.ok }
    return data
};

export const addSkillMedia = (payload) => {
    return apiInstance.post("skill/addSkillMedia", payload, { headers: getToken() });
};

export const deleteSkillMediaById = async (payload) => {
    const res = await apiInstance.delete(`skill/deleteSkillMediaById/${payload?.id}`, { headers: getToken() });
    return res;
};

export const getSkillQuizesById = async (payload) => {
    const res = await apiInstance.get(`skill/${payload}`);
    let data = { data: { records: res?.data?.quizzes, totalRecords: res?.data?.quizzes?.length }, ok: res?.ok }
    return data;
};

export const deleteSkillQuizById = (payload) => {
    return apiInstance.post("skill/deleteSkillQuizById", payload, { headers: getToken() });
};

export const addSkillQuiz = (payload) => {
    return apiInstance.post("skill/addSkillQuiz", payload, { headers: getToken() });
};



